import { ActionIcon, Flex, Select } from "@mantine/core";
import { TimeInput } from "@mantine/dates";
import { IconClock } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useRef } from "react";
import { useSelector } from "src/redux/hooks";

import { useInputProps } from "../hooks/useInputProps";

interface ITimeInputWithTimeZone {
  value: string;
  id: string;
  suffix?: string;
  required?: boolean;
  disabled?: boolean;
  utcOnly?: boolean;
}

const TimeInputWithSuffix = ({
  value,
  id,
  suffix,
  required,
  disabled,
  utcOnly,
}: ITimeInputWithTimeZone) => {
  const { ref: addToRefs, ...inputProps } = useInputProps(id, value, required);

  const globalSuffix = useSelector(state => state.generatorSlice.timeZone);
  const datecreated = useSelector(
    state => state.generatorSlice.entryDataToSave.datecreated,
  );

  const getDefaultTZ = () => {
    const borderDay = dayjs().year(2024).month(2).date(27);
    return dayjs(datecreated).isAfter(borderDay) ? "LT" : "UTC";
  };

  const ref = useRef<HTMLInputElement | null>(null);
  const selectDisabled = disabled || utcOnly;
  return (
    <Flex gap={5}>
      <TimeInput
        onClick={() => ref.current && ref.current.showPicker()}
        style={{
          flex: 1,
          opacity: disabled ? 0.3 : 1,
          pointerEvents: disabled ? "none" : "auto",
        }}
        ref={r => {
          ref.current = r;
          addToRefs(r);
        }}
        rightSection={
          <ActionIcon size="sm" onClick={() => ref.current?.showPicker()}>
            <IconClock size="1rem" stroke={1.5} />
          </ActionIcon>
        }
        {...inputProps}
      />
      <Select
        style={{
          opacity: selectDisabled ? 0.3 : 1,
          pointerEvents: selectDisabled ? "none" : "auto",
        }}
        w={"83px"}
        value={utcOnly ? "UTC" : suffix ?? globalSuffix ?? getDefaultTZ()}
        data={[
          {
            value: "LT",
            label: "LT",
          },
          {
            value: "UTC",
            label: "UTC",
          },
        ]}
      />
    </Flex>
  );
};
export default TimeInputWithSuffix;
